import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isAuthenticated(): Promise <boolean> {
    return new Promise((resolve) => {
      const user = this.getAuthorizationToken();
      const projectId = sessionStorage.getItem('projectId');
      if (user && projectId) {
        resolve(true);
      }
      resolve(false);
    });
  }

  saveLocalStorage(user: any, isSaml?: boolean): Promise<any> {
    return new Promise((resolve) => {
      const userID = user.user._id || user.user.id;
      localStorage.setItem('id', userID);
      localStorage.setItem('authToken', user.token);
      localStorage.setItem('name', user.user.name);
      localStorage.setItem('role', user.user.role);
      resolve(true);
    });
  }

  removeLocalStorage(): Promise<any> {
    return new Promise<any>((resolve) => {
      sessionStorage.clear();
      localStorage.clear();
      resolve(true);
    });
  }

  getAuthorizationToken() {
    return localStorage.getItem('authToken');
  }

}
